import { zodValidator } from '@tanstack/zod-adapter';
import type { util } from 'zod';
import type { FilterRouteConfig } from './FilterBar';
import { type FilterSearchSchema, filterSchema } from './registry';
import { useFilterState } from './useFilterState';

// Main component exports
export { FilterBar } from './FilterBar';
export type { FilterBarProps, FilterConfig } from './FilterBar';

/**
 * Create a filter config object
 * - config: used to describe filter settings
 * - schema: used to validate filter values
 * - filterSearchValidator: TSR validator for the schema
 * - useFilters: hook to subscribe to filter changes
 */
export const createFilterConfig = <
  Mask extends util.Exactly<
    {
      [k in keyof FilterSearchSchema]?: true;
    },
    Mask
  >,
>(
  config: FilterRouteConfig,
  pickFromFilters: Mask
) => {
  const schema = filterSchema.pick(pickFromFilters);

  return {
    config,
    schema: schema,
    filterSearchValidator: zodValidator(schema),
    useFilters: () => useFilterState(schema, config.routeId),
  };
};

export type CreateFilterConfigReturnType = ReturnType<
  typeof createFilterConfig<{
    [k in keyof FilterSearchSchema]: true;
  }>
>;
